import { API_ENDPOINTS } from 'services/api';
import httpClient from 'services/httpClient';
import {
  SchoolCompetencyResponse,
  SchoolDataForm,
  SchoolJobFamilyForm,
  SchoolJobFamilyResponse,
  UpdateSchoolJobFamilyForm
} from 'types/dacum/schoolManagement';

interface Params {
  search?: string;
  pageNumber?: number;
  pageSize?: number;
  status?: string;
  sortBy?: string;
  startDate?: string;
  endDate?: string;
  schoolId?: string | null;
  sortOrder?: 'asc' | 'desc';
}

export const schoolService = {
  createSchool: async (data: SchoolDataForm) => {
    const response = await httpClient.post(API_ENDPOINTS.DACUM.SCHOOL_MANAGEMENT.ADD, data);
    return response.data;
  },
  updateSchool: async (data: SchoolDataForm & { msSchoolCompetencyManagementID: string }) => {
    const response = await httpClient.put(API_ENDPOINTS.DACUM.SCHOOL_MANAGEMENT.UPDATE, data);
    return response.data;
  },
  deleteSchool: async (data: { msSchoolCompetencyManagementID: string }) => {
    const response = await httpClient.delete(API_ENDPOINTS.DACUM.SCHOOL_MANAGEMENT.DELETE, {
      data
    });
    return response.data;
  },
  detailSchool: async (id: string) => {
    const response = await httpClient.get(`${API_ENDPOINTS.DACUM.SCHOOL_MANAGEMENT.DETAIL}/${id}`);
    return response.data;
  },
  getSchoolCompetency: async (params?: Params): Promise<SchoolCompetencyResponse> => {
    const response = await httpClient.get<SchoolCompetencyResponse>(
      API_ENDPOINTS.DACUM.SCHOOL_MANAGEMENT.LIST,
      {
        params
      }
    );
    return response.data;
  },
  getSchoolJobFamilyList: async (params?: Params): Promise<SchoolJobFamilyResponse> => {
    const response = await httpClient.get<SchoolJobFamilyResponse>(
      API_ENDPOINTS.DACUM.SCHOOL_JOB_FAMILY.LIST,
      {
        params
      }
    );
    return response.data;
  },
  getSchoolJobFamilyDetail: async (id: string) => {
    const response = await httpClient.get(`${API_ENDPOINTS.DACUM.SCHOOL_JOB_FAMILY.DETAIL}/${id}`);
    return response.data;
  },
  createSchoolJobFamily: async (data: SchoolJobFamilyForm) => {
    const response = await httpClient.post(API_ENDPOINTS.DACUM.SCHOOL_JOB_FAMILY.ADD, data);
    return response.data;
  },
  updateSchoolJobFamily: async (data: UpdateSchoolJobFamilyForm) => {
    const response = await httpClient.put(API_ENDPOINTS.DACUM.SCHOOL_JOB_FAMILY.UPDATE, data);
    return response.data;
  },
  deleteSchoolJobFamily: async (data: { TrSchoolJobFamilyID: string }) => {
    const response = await httpClient.delete(API_ENDPOINTS.DACUM.SCHOOL_JOB_FAMILY.DELETE, {
      data
    });
    return response.data;
  },
  getBusinessUnitsForDacum: async () => {
    const response = await httpClient.get(API_ENDPOINTS.LCMS.COURSES.BUSINESS_UNIT_CREATE_LCMS, {
      params: { pageNumber: 1, pageSize: 20000, source: 'dacum' }
    });
    return response.data;
  }
};
